import { FC } from 'react'
import { observer } from 'mobx-react'
import { Trans, useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { getUserAvatar, useStores } from '../../../utils'
import styles from './index.module.scss'
import { Avatar } from '../../atoms/Avatar'
import { NoContent } from '../../atoms/NoContent'

export const JobApplicationModalLeftContent: FC = observer(() => {
  const { t } = useTranslation(['companies-users-[id]', 'validation'])
  const { ui, viewer } = useStores()
  const router = useRouter()

  let bio = ''
  if (viewer.viewer.profile?.bio) {
    const maxLength = ui.isMobile ? 43 : 55
    const bioPrefix = viewer.viewer.profile.bio.substring(0, maxLength)
    const bioSuffix = viewer.viewer.profile.bio.length > maxLength ? '...' : ''
    bio = `${bioPrefix}${bioSuffix}`
  }

  return (
    <>
      <div className={styles.item}>
        <p className={styles.itemLabel}>{t('基本プロフィール')}</p>
        <div className={styles.applicant}>
          <div className={styles.avatar}>
            <Avatar src={getUserAvatar(viewer.viewer)} alt={viewer.viewer.name} />
          </div>
          <div className={styles.nameContent}>
            <div className={styles.name}>{viewer.viewer.name}</div>
            <div className={styles.jobTitle}>{viewer.viewer.profile?.jobTitle}</div>
          </div>
        </div>
        <div className={styles.bio}>{bio}</div>
      </div>

      <div className={styles.item}>
        <p className={styles.itemLabel}>{t('求職ステータス')}</p>
        <p className={styles.jobItem}>{t(viewer.viewer.profile?.jobHuntingStatus)}</p>
      </div>

      <div className={styles.item}>
        <p className={styles.itemLabel}>{t('主な職種（経験年数）')}</p>
        <p className={styles.jobItem}>{`${t(viewer.viewer.profile?.primaryJobCategory.name)}（${t(
          viewer.viewer.profile?.yearsOfExperience
        )}）`}</p>
      </div>

      <div className={styles.skillContent}>
        <p className={styles.itemLabel}>{t('スキル')}</p>
        <div className={styles.skills}>
          {viewer.viewer.profile?.skills.length === 0 ? (
            <NoContent>{t('スキルがまだ登録されていません。')}</NoContent>
          ) : (
            viewer.viewer.profile?.skills.map((skill) => {
              return (
                <div key={skill.id} className={styles.jobItem}>
                  {skill.name}
                </div>
              )
            })
          )}
        </div>
      </div>

      <div className={styles.textItem}>
        <div className={styles.text}>
          <Trans i18nKey='companies-users-[id]:プロフィール入力促進のテキスト'>
            採用担当者は上記の内容であなたを評価します。
            <br />
            可能な限りプロフィールを充実させて返信率を高めましょう。
          </Trans>
        </div>
      </div>
      <a className={styles.link} href={`/${router.locale}/account/profile/job`} target='_blank' rel='noreferrer'>
        <span className={styles.linkText}>{t('プロフィール編集画面へ')}</span>
        <img src='/images/common/service_link_icon.svg' alt='Profile Link' className={styles.linkIcon} />
      </a>
    </>
  )
})
